import {
  afterNextRender,
  Component,
  ElementRef,
  inject,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerComponent } from '../../components/container/container.component';
import { MyPageSideBarComponent } from './components/my-page-side-bar/my-page-side-bar.component';
import { NavigationEnd, Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-my-page',
  standalone: true,
  imports: [
    CommonModule,
    ContainerComponent,
    MyPageSideBarComponent,
    RouterModule,
  ],
  templateUrl: './my-page.page.html',
  styleUrl: './my-page.page.scss',
})
export default class MyPagePage {}
